import { toast } from 'react-toastify';

/**
 * Show dynamic toast (success/error)
 * @param {string} message - Message to display
 * @param {'success'|'error' |'info'| 'warning'} type - Toast type
 */
const showToast = (message, type = 'success') => {
  if (!message) return;

  // Width grows with message length
  const width = Math.min(100 + message.length * 8, 400);

  // Duration grows with message length
  const duration = Math.min(2000 + message.length * 50, 10000);

  const options = {
    style: {
      // width: `${width}px`,
      maxWidth: '90vw', // prevents overflow on small screens
      whiteSpace: 'normal', // allows text to wrap
      wordBreak: 'break-word', // prevents very long words from overflowing
    },
    autoClose: duration,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  if (type === 'success') toast.success(message, options);
  else if (type === 'info') toast.info(message, options);
  else if (type === 'warning') toast.warning(message, options);
  else toast.error(message, options);
};

export default showToast;
